import { api } from '../api/client'

// Tells the server about trouble it can't see itself (backend
// problems.py): a script error on a page, a page that failed to draw, a
// request that never arrived. Errors the server answered with a status
// are its own to record. The same message on the same page is sent once
// a minute at most; the server keeps the rest in check too.

export const BUILD = typeof __ASYS_BUILD__ !== 'undefined' ? __ASYS_BUILD__ : 'dev'

const sent = new Map()
const here = () => (typeof window === 'undefined' ? '' : window.location.pathname)

export function reportProblem({ message, detail, source } = {}) {
  try {
    const text = String(message || '').trim().slice(0, 500)
    if (!text) return
    const key = text.replace(/\d+/g, '#').slice(0, 200) + '|' + here()
    const now = Date.now()
    if (sent.get(key) && now - sent.get(key) < 60000) return
    sent.set(key, now)
    api.post('/problems/report', {
      message: text,
      detail: String(detail || '').slice(0, 8000),
      page: here(),
      source: source || 'web',
      version: BUILD,
    }).catch(() => { })
  } catch {
    // reporting trouble must never cause more
  }
}

/** Script errors and promises nobody caught. Errors from API calls carry a status and are left to the server. */
export function watchForProblems() {
  if (typeof window === 'undefined') return
  window.addEventListener('error', (e) => {
    const err = e.error
    reportProblem({ message: e.message || String(err || 'Script error'), detail: err && err.stack })
  })
  window.addEventListener('unhandledrejection', (e) => {
    const r = e.reason
    if (r && r.status) return
    // Something cancelled on purpose (a camera closed while its video was
    // starting, an aborted request) isn't a fault.
    if (r && r.name === 'AbortError') return
    reportProblem({ message: (r && r.message) || String(r || 'Unhandled rejection'), detail: r && r.stack })
  })
}
